import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-app-analytics-ui',
  templateUrl: './app-analytics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsAppAnalyticsComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly appAnalytics = output<boolean>();

  public readonly appAnalyticsForm = this.fb.group({
    appAnalyticsEnabled: [false],
  });

  get appAnalyticsEnabled() {
    return this.appAnalyticsForm.get('appAnalyticsEnabled') as UntypedFormControl;
  }

  onSubmit() {
    this.appAnalytics.emit(this.appAnalyticsEnabled.value);
  }
}
